import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WidgetProjectPreviewPageComponent } from './widget-project-preview-page.component';
import { WidgetCoreModule } from '@gspwidget/widget-core';
import { ConfigEditor2Module } from '../config-editor2/config-editor2.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [WidgetProjectPreviewPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    WidgetCoreModule,
    ConfigEditor2Module,
    TranslateModule
  ],
  exports: [WidgetProjectPreviewPageComponent]
})
export class WidgetProjectPreviewPageModule { }
